module.exports = __webpack_public_path__ + "img/galery24.185cc05c.jpg";